import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { SectionHeading } from "./Reveal";

const faqs = [
  {
    q: "Che differenza c'è tra SAB e REC?",
    a: "Il corso SAB (Somministrazione di Alimenti e Bevande) ha sostituito il vecchio REC. Chi possedeva il REC mantiene la validità dell'abilitazione, mentre per le nuove attività è richiesta l'abilitazione SAB.",
  },
  {
    q: "L'attestato è valido in tutta Italia?",
    a: "Sì. Superando l'esame finale davanti alla Commissione d'esame, ottieni un attestato di abilitazione riconosciuto e valido su tutto il territorio nazionale, per aprire bar, ristoranti, pizzerie, supermercati e qualsiasi attività alimentare.",
  },
  {
    q: "Posso frequentare il corso online?",
    a: "Sì, oltre alla modalità in presenza nella sede di Milano è disponibile la modalità online (FAD). La frequenza resta obbligatoria e l'esame finale si svolge secondo la disciplina di Regione Lombardia.",
  },
  {
    q: "Quanto dura il corso e quando inizia la prossima edizione?",
    a: "Il corso ha durata di 130 ore. La prossima edizione in presenza inizia il 26 ottobre 2026, con lezioni dalle 14:00 alle 18:00. I posti sono limitati: ti consigliamo di prenotare in anticipo.",
  },
  {
    q: "È possibile pagare a rate?",
    a: "Sì, contattaci al 351 393 7976 o tramite il modulo: valutiamo insieme soluzioni di pagamento personalizzate e rateizzate.",
  },
  {
    q: "Ho un diploma alberghiero: devo comunque fare il corso?",
    a: "Alcuni titoli di studio ed esperienze lavorative danno diritto all'esenzione totale o parziale. Contattaci con il tuo titolo: verifichiamo gratuitamente la tua posizione.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="border-t border-line bg-white py-16 md:py-24" data-testid="faq-section">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Domande frequenti"
          title="Tutto quello che devi sapere"
          testid="faq"
        />
        <div className="mt-10 divide-y divide-line border-y border-line">
          {faqs.map((f, i) => (
            <div key={f.q}>
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                className="flex w-full items-center justify-between gap-4 py-5 text-left"
                data-testid={`faq-question-${i}`}
              >
                <span className={`font-heading text-base font-bold tracking-tight sm:text-lg ${open === i ? "text-brand-amber" : "text-navy"}`}>
                  {f.q}
                </span>
                <Plus
                  className={`h-5 w-5 shrink-0 transition-transform duration-300 ${open === i ? "rotate-45 text-brand-amber" : "text-slate-400"}`}
                />
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                    className="overflow-hidden"
                  >
                    <p className="pb-6 pr-10 text-sm leading-relaxed text-slate-600 sm:text-base" data-testid={`faq-answer-${i}`}>
                      {f.a}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
